import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Navbar from '@/components/Partials/Navbar.vue';
import Wrapper from '@/components/Partials/Wrapper.vue';
import Fragment from 'vue-fragment'
import DeleteModal from "@/components/Reuse/DeleteModal.vue";
import LoadingButton from '@/components/Reuse/LoadingButton.vue';
import vSelect from 'vue-select'
import { store } from './store';
import Notifications from 'vue-notification'
import Preloader from '@/components/Reuse/Preloader.vue';

Vue.component("navbar",Navbar);
Vue.component("wrapper",Wrapper);
Vue.component("delete-modal",DeleteModal);
Vue.component('loading-btn', LoadingButton)
Vue.use(Fragment.Plugin)
Vue.component('v-select', vSelect)
Vue.use(Notifications)
Vue.component('pre-loader', Preloader)
Vue.use(require('vue-moment'));

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
